export function dropdown() {
    const dropdowns = $(".dropdown");
    const expandBtn = dropdowns.find(".expand-btn");
    const headerHeight = $(".main-header").height();
    expandBtn.on("click", function () {
        const correction = (window.innerWidth < 1200) ? headerHeight + 35 : headerHeight + 10;
        $(this).parents(".dropdown").toggleClass("active").siblings().removeClass("active");
        setTimeout(() => {
            $("html, body").animate({
                scrollTop: $(this).offset().top - correction
            }, 700);
        }, 1000);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/dropdown.js